<div class="container-fluid pl-0 pr-0">
  <div class="row mx-0 seriesBackground"  [ngStyle]="{'background' : 'url('+ seriesinfo?.info.backdrop_path +') no-repeat '}">
    <div class="col-md-12 mt-3 pl-5 mobile" *ngIf="seriesinfo">
      <div class="row mt-0 mt-lg-5 ">
        <div class="col-md-7">
          <div class="row">
              <div class="col-12 text-left">
                <div class="bd-highlight infotitle">{{seriesinfo.info.name}}</div>
                <div class=" d-lg-block">
                  <div class="d-flex flex-row bd-highlight mb-2 mt-2">
                    <div class="bd-highlight category">{{seriesinfo.info.releaseDate |date:'YYYY'}} <span
                        class="mx-2 text-purple"></span>
                    </div>
                    <!-- <div class="bd-highlight category">{{seriesinfo.info.genre | slice:0:15}} 
                    </div> -->
                    <!-- <span class="mx-2 fs-22 text-purple">|</span> -->
                    <div class="bd-highlight season-len "> 
                      <div class="season-text">
                        {{ 'SERIES.SEASONS' | translate }} {{seasonLen}}
                      </div>
                      <span class="mx-2 fs-22 text-purple"></span>
                    </div>
                      <span class="mx-2 fs-22 text-purple"></span>
                      <div class="mb-lg-5 mb-3 fs-20">
                        <i class="fa fa-star text-warning"></i>
                        {{seriesinfo?.info?.rating}}
                        <!-- <i
                          class="fa fa-star mx-1"
                          [ngClass]="{
                            'text-purple': movieinfo.info.rating / 2 >= i + 1
                          }"
                          aria-hidden="true"
                          *ngFor="let item of [1, 2, 3, 4, 5]; let i = index"
                        ></i> -->
                      </div>
                    <!-- <div type="" class=" mr-lg-4 d-flex fav-center" *ngIf="!isFavourit" (click)="onSave(seriesinfo)"><i
                    class="fa fa-heart  px-3 px-lg-2 py-1"></i>{{ 'COMMON.ADD_TO_FAVOURITE' | translate }}</div>
                    <div type="" class=" mr-lg-4 d-flex fav-center" *ngIf="isFavourit" (click)="deleteFavourite(seriesinfo)"><i
                      class="fa fa-trash  px-3 px-lg-2 py-1"></i>{{ 'COMMON.REMOVE_FROM_FAVOURITE' | translate }}</div> 
                    <div class="d-flex"> -->
                      <span class="mx-2 fs-22 text-purple"></span>
  
                    <div type="" class=" mr-lg-4 ng-star-inserted mb-0 fs-19 fw-700 fav-center" (click)="onSave(seriesinfo)" *ngIf="!isFavourit">
                      <!-- <span class="mx-2 fs-22 text-purple">|</span> -->
                      <i class="far fa-heart   px-lg-2 py-lg-1 fs-22 "></i>
                    </div>
                     <div type="" class=" mr-lg-4 ng-star-inserted  mb-0 fs-19 fw-700 fav-center" (click)="deleteFavourite(seriesinfo)" *ngIf="isFavourit">
                    <!-- <span class="mx-2 fs-22 text-purple">|</span> -->
                    <i class="fa fa-heart px-lg-2 py-lg-1 fs-22"></i>
                  </div>
                </div>
                <div class="bd-highlight category fs-20">{{seriesinfo.info.genre || 'N/A'}}</div> 
                </div>
                <!-- <div class="d-lg-none d-block">
                  <div class="fs-14">{{seriesinfo.info.releaseDate}}</div>
                  <div class="fs-14">{{seriesinfo.info.genre}}</div>
                  <div class="fs-14">{{seasonLen}}{{ 'SERIES.SEASON' | translate }},{{episodeLen}}
                    {{ 'SERIES.EPISODE' | translate }}</div>
                    <p class="fs-16 text-light xs-res" *ngIf="!isFavourit" (click)="onSave(seriesinfo)"><i
                      class="fa fa-heart  pl-0"></i>&nbsp; Add favourits</p>
                   <p class="fs-16 text-light xs-res" *ngIf="isFavourit" (click)="deleteFavourite(seriesinfo)"><i
                    class="fa fa-trash   pl-0"></i>&nbsp; Remove favourits</p>
                </div> -->
                <!-- <div class="mb-3">
                  <i class="fa fa-star mx-1" [ngClass]="{'text-purple':(seriesinfo.info.rating/2)>=i+1 }"
                    aria-hidden="true" *ngFor="let item of [1,2,3,4,5];let i=index;"></i>
                </div> -->
                <!-- <div>
                  <p class="text-white  content-text  ">{{seriesinfo.info.plot}}</p>
                </div> -->
  
              </div>
          </div>
        </div>
        <div class="col-md-5 img-contain mx-auto">
          <div class="image-overlays" >
            <!-- <img [src]="seriesinfo.info.cover" class="info-img" alt="No image" loading=lazy> -->
          </div>
          <div class="fav-icon icon-color" *ngIf="isFavourit"> 
            <!-- <i class="fas fa-heart"></i> -->
          </div>
        </div>
        <!-- <div class="col-12 text-center cursor-pointer season-scroll-btn d-flex ">
          <div class="season-name"  *ngFor="let item of seriesinfo.seasons;let i=index;" class="d-flex" >
            <h4 class="episode-title d-flex  mr-5" (click)="onSelectSeasons(item.season_number)" [ngClass]="{'border-all':item.season_number==seasonId}">{{item.name}}</h4>
          </div>
        </div> -->
        <div class="col-12 season-scroll-wrapper mt-4 cursor-pointer" [ngStyle]="{'margin-left':isScrollable ? '0.5rem':'0rem'}">
        <button *ngIf="isScrollable" (click)="scrollLeft()" [disabled]="isAtStart" class="scroll-btn left"><i class="fas fa-arrow-left fs-24"></i></button>
        <div class="scroll-container" #scrollContainer>
          <div class="season-name mt-2" [ngStyle]="{'margin-left':isScrollable ? '3rem' :'0rem'}"  #seriesItem *ngFor="let item of seriesinfo.seasons;let i=index;">
            <h4 class="episode-title mr-5" 
            (click)="onSelectSeasons(item.season_number)" 
            [ngClass]="{'border-all': item.season_number == seasonId}">
            {{ item.name }}
            </h4>
          </div>
        </div>
        <button *ngIf="isScrollable" (click)="scrollRight()" [disabled]="isAtEnd" class="scroll-btn right"><i class="fas fa-arrow-right fs-24"></i></button>
        </div>
          <!-- <ngx-slick-carousel class="carousel custom-slider" #slickModal="slick-carousel" [config]="slideConfig">
            <div ngxSlickItem *ngFor="let item of seriesinfo.seasons;let i=index;" class="slide series-slide"
              (click)="onSelectSeason(item.season_number)" style="width: 220px !important;">
              <div class="pr-md-3 pr-4">
                <a class="cursor-pointer" *ngIf="seriesinfo.episodes">
                  <img class="slide-img" [src]="item.cover" loading=lazy
                    [ngClass]="{'border-all':item.season_number==seasonId}" alt="First slide">
                  </a>
                <a class="cursor-pointer" *ngIf="!seriesinfo.episodes">
                  <img class="search-img "  loading=lazy
                    [ngClass]="{'border-all':item.season_number==seasonId}" alt="First slide"
                    [routerLink]="['/series/list/'+this.id]"></a>
                <p class="episode-title">{{item.name}}</p>
              </div>
            </div>
          </ngx-slick-carousel> -->

        <div class="col-12 text-left pt-4 pb-4" *ngIf="seriesinfo?.episodes">
          <!-- <h4>{{ 'SERIES.EPISODES' | translate }}</h4> -->
          <!-- <p *ngIf="!seriesinfo.selectedEpisodes || 
          (seriesinfo.selectedEpisodes && seriesinfo.selectedEpisodes.length == 0)">{{'COMMON.DATA_NOT_FOUND' | translate}}</p> -->
          <ng-container *ngIf="(seriesinfo?.episodes[seasonId]|filter:filterTerm)?.length; else noData">
          <ngx-slick-carousel class="carousel custom-slider" #slickModal="slick-carousel" [config]="slideConfig">
            <!-- <div ngxSlickItem *ngFor="let item of seriesinfo.episodes[seasonId];let i=index;" -->
            <div ngxSlickItem *ngFor="let item of seriesinfo?.selectedEpisodes; index as i;"
              class="slide cursor-pointer" (click)="playSeries(item)">
              <div class="pr-3">
                <div class="pr-3">
                  <div class="vlc-player" style="position: absolute;z-index: 999;top: 0.5rem;">
                    <!-- <img   (click)="openVlcs($event, item)" src="./assets/images/new_icons/player.png" height="35px" width="35px" alt="" class=" ml-2"> -->
                  </div>
                  <img class="search-imgseries" [src]="item.info.movie_image" alt="First slide" loading=lazy>
                  <p class="fs-14 search-title " title="{{ item.title }}">{{item.title }}</p>
                </div>
              </div>
            </div>
           
          </ngx-slick-carousel>
        </ng-container>
        <ng-template #noData>
          <div class="col-lg-12  col-xl-12 col-12 text-center">
            <h2 class="fs-32">
              {{ 'COMMON.DATA_NOT_FOUND' | translate }}
            </h2>
          </div>
        </ng-template>
        </div>
      </div>
  </div>
</div>

<!-- <div class="container-fluid">
  <div class="row my-3 mx-2 " *ngIf="seasonId">
    <div class="col-12 px-0">
      <div class="form-group has-search  mr-2">
        <span class="fa fa-search form-control-feedback"></span>
        <input type="text" class="form-control" placeholder="{{ 'COMMON.SEARCH_HERE' | translate }}"
          [(ngModel)]="filterTerm">
        <button type="button" class="btn bg-transparent searchclear" *ngIf="filterTerm" (click)="filterTerm=''">
          <i class="fa fa-times"></i>
        </button>
      </div>
    </div>
  </div>
  <div class="row mx-md-3 mx-0">
    <div class="col-md-12 d-flex mt-2">
      <div class="ml-auto mr-auto">
        <h3 class="text-center series-header">{{seriesinfo?.info.name}}</h3>
      </div>
      <div class="spinner-border  mt-2 mr-2 " role="status" *ngIf="isLoading">
        <span class="sr-only">{{ 'COMMON.LOADING' | translate }}</span>
      </div>
    </div>
    <div class="col-md-12 mb-0 pb-0">
      <h3 class="text-left mb-0 pb-0  series-header" *ngIf="seriesinfo">{{ 'SERIES.SEASONS' | translate }}</h3>
    </div>
    <div class="col-lg-3  col-xl-2 col-6 text-left " *ngFor="let select of seriesinfo?.seasons; index as i">
      <div class="imageContainer-search cursor-pointer" (click)="onSelectSeason(select.season_number)">
        <div [ngClass]="{'border-all':select.select}">
          <img [src]="select.cover" class="search-img" loading=lazy>
        </div>
      </div>
      <h6 class="mt-2">{{ 'SERIES.SEASON' | translate }} {{select.season_number}}</h6>
    </div>

  </div>
  <div class="row mx-md-3 mx-0 my-3  border-top" *ngIf="seasonId && seriesinfo?.episodes">
    <div class="col-md-12 mt-3">
      <h3 class="text-center series-header">{{ 'SERIES.SEASONS' | translate }} {{seasonId}}</h3>
    </div>
    <div class="col-md-12 mb-0 pb-0">
      <h3 class="text-left mb-0 pb-0 series-header">{{ 'SERIES.EPISODES' | translate }}</h3>
    </div>
    <ng-container *ngIf="(seriesinfo?.episodes[seasonId]|filter:filterTerm)?.length; else noData">
    <div class="col-lg-4  col-xl-3 col-6 text-left "
      *ngFor="let select of seriesinfo?.episodes[seasonId]|filter:filterTerm; index as i">
      <div class="mb-4 imageContainer-search">
        <div>
          <img [src]="select.info.movie_image" class="search-image">
        </div>


        <div class="d-flex mt-2">
          <h6 class=" search-title mb-1" title="{{select.title }}">{{select.title}}</h6>
          <a class="ml-auto" [routerLink]="'/series/watch/' + select.id + '/' + select.container_extension"
            ><i class="fas fa-play-circle fs-18 text-purple ml-auto cursor-pointer"></i></a>
        </div>

        <h6 class="text-purple episode-title" *ngIf="select.dur"><span
            class="mr-1">{{ 'SERIES.DURATION' | translate }}:</span><span
            *ngIf="select.dur?.hour>0">{{select.dur?.hour}}
            H</span> <span>{{select.dur?.minute}}m</span> </h6>

      </div>
    </div>
  </ng-container>
  <ng-template #noData>
    <div class="col-lg-12  col-xl-12 col-12 text-center">
      <h2 class="fs-32">
        {{ 'COMMON.DATA_NOT_FOUND' | translate }}
      </h2>
    </div>
  </ng-template>
  </div>
</div> -->
